import React, { useState } from 'react';
import { PlusCircle, FileText } from 'lucide-react';
import TranslationNavBarComponent from '../generic/TranslationNavBarComponent';
import { useNavigate } from 'react-router-dom';

const items = [
    { id: 1, title: 'My Requests', 'url': '/translations/myrequests' },
];

const TranslationsHomeScreen: React.FC = () => {
    const [menuItems] = useState(items);
    const [selectedItem, setSelectedItem] = useState<number | null>(null);
    const navigate = useNavigate();

    const handleNewTranslation = () => {
        console.log('Creating new translation');
        navigate("/translations/create");
    };

    const handleMenuItemClick = (id: number, url: string) => {
        setSelectedItem(id);
        navigate(url);
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            {/* Header */}
            <TranslationNavBarComponent />
            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar */}
                    <div className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
                        <div className="position-sticky pt-3">
                            <ul className="nav flex-column">
                                <li className="nav-item">
                                    <button
                                        className="btn btn-primary w-100 mb-3"
                                        onClick={handleNewTranslation}
                                    >
                                        <PlusCircle className="me-2" size={18} />
                                        New Translation
                                    </button>
                                </li>
                                {menuItems.map((translation) => (
                                    <li key={translation.id} className="nav-item">
                                        <a
                                            href="#"
                                            className={`nav-link ${selectedItem === translation.id ? 'active' : ''}`}
                                            onClick={() => handleMenuItemClick(translation.id, translation.url)}
                                            style={{
                                                backgroundColor: selectedItem === translation.id ? '#007bff' : 'transparent',
                                                color: selectedItem === translation.id ? '#ffffff' : '#000000',
                                            }}
                                        >
                                            <FileText className="me-2" size={18} />
                                            {translation.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Main content */}
                    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                            <h1 className="h2">Translations</h1>
                        </div>
                        <p>Select a translation from the sidebar or create a new one.</p>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default TranslationsHomeScreen;
